// 3rd party imports
import * as React from 'react';
import { Link } from 'react-router-dom';

// shared-ui
import { ILocalization } from '@shared-ui/localization-context';

// mobx
import { Program } from 'models';

// ui
import { UitkText } from 'uitk-react-text';
import { UitkList, UitkListItem } from 'uitk-react-list';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

export interface ProgramCardFeaturesProps {
  program: Program;
  l10n?: ILocalization;
}

export const ProgramCardFeatures: React.FunctionComponent<ProgramCardFeaturesProps> = ({
  program,
  l10n,
}) => {

  function tooltipCode(dialogId) {
    return (
      <Link to={{search: `pwaDialog=${dialogId}-${program.name}`}}>
        <UitkIcon name="info_outline" size={UitkIconSize.SMALL} />
      </Link>
    )
  }

  return (
    <UitkText align="center">
      <UitkList bullet="no-bullet">
        {program.features.map((feature, index) => (
          <UitkListItem key={index}>
            <UitkText>
              <span>{l10n.formatText(`programs.${program.name}.${feature.name}`)}</span>&nbsp;
              {feature.hasTooltip &&
                tooltipCode(feature.tooltipDialogPrefix)
              }
            </UitkText>
          </UitkListItem>
        ))}
      </UitkList>
    </UitkText>
  );
};
